import { Component, OnInit, Renderer2, ElementRef, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';

// Service
import { ApiService } from '../../shared/service/api.service';

// Plugin
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styles: [
  ]
})
export class HeaderComponent implements OnInit{
  
  @ViewChild('langen', {static: true}) el_en:ElementRef;
  @ViewChild('langid', {static: true}) el_id:ElementRef;
  @ViewChild('langen2', {static: true}) el_en2:ElementRef;
  @ViewChild('langid2', {static: true}) el_id2:ElementRef;
  dataHeader;
  search = new FormControl('');
  lang;
  openListMenu:boolean;
  openLang:boolean;
  isDesktop;

  constructor(  private renderer: Renderer2, 
                private elem: ElementRef, 
                private apiService: ApiService, 
                private router : Router,
                private deviceService: DeviceDetectorService) { }

  ngOnInit(): void {
    this.isDesktop = this.deviceService.isDesktop();

    // data header
    this.apiService.getDataApi('getMenu').subscribe(response => {
      this.dataHeader = response.data;
    });

    this.apiService.lang.subscribe(data => {
        this.lang = data;
        if(this.lang == 'en'){
          this.el_en.nativeElement.style.color = 'red';
          this.el_id.nativeElement.style.color = 'white';
          this.el_en2.nativeElement.style.color = 'red';
          this.el_id2.nativeElement.style.color = 'white';
        }else {
          this.el_id.nativeElement.style.color = 'red';
          this.el_en.nativeElement.style.color = 'white';
          this.el_id2.nativeElement.style.color = 'red';
          this.el_en2.nativeElement.style.color = 'white';
        }
    });
  }

  onOpenMenu(){
    this.openListMenu = !this.openListMenu;
    if( this.openListMenu === true ){
      this.renderer.addClass(document.body, 'overflow-hidden');
    }else{
      this.closeMenu();
    }
  }
  
  closeMenu(){
    this.openListMenu = false;
    this.renderer.removeClass(document.body, 'overflow-hidden');
    this.renderer.removeStyle(document.body, 'overflow');
    const elements = this.elem.nativeElement.querySelectorAll('.menu-children .w-menu');
    let i;
    for(i=0;i<elements.length;i++) {
      this.renderer.removeClass(elements[i], 'active');
    }
  }

  onSearch(ev){
    if (ev.keyCode === 13 || ev.type === 'click' ) {
      this.router.navigate(['/search'], { queryParams: { key: this.search.value } });
      this.closeMenu();
    }
  }

  onOpenLang(){
    this.openLang = !this.openLang;
  }

  changeLanguage(param){
    if(param != this.lang){
      location.reload();
      this.apiService.giveLang(param);
      if (typeof(Storage) !== "undefined") {
        // Store
        window.localStorage.setItem("language", param);
      } else {
        window.localStorage.setItem("language", "en");
      }
    }
  }
  
  onOpenDropdown(ev){
    const target = ev.currentTarget;
    const parent = this.renderer.parentNode(target);
    const elements = this.elem.nativeElement.querySelectorAll('.menu-children .w-menu');
    if(parent.classList.contains('active')){
      this.renderer.removeClass(parent, 'active');
    }else{
      let i;
      for(i=0;i<elements.length;i++) {
        this.renderer.removeClass(elements[i], 'active');
      }
      this.renderer.addClass(parent, 'active');
    }
  }

  onPrevent(ev){
    ev.stopPropagation();
  }

}
